import { ChangeDetectorRef, Component, HostListener, Renderer2, ViewChild, ViewContainerRef } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { SharedService } from "./Services/sharedService";
import { ProjectService } from "./Services/project.service";
import { TourService } from 'ngx-ui-tour-md-menu'
import { TourConfigService } from "./Services/tour-config.service";
import { WelcomeComponent } from "./welcome/welcome.component";
import { Observable, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
// import { config } from "./config";
import Feedback from "@betahuhn/feedback-js";
import * as platform from 'platform';
import html2canvas from 'html2canvas';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ComponentDrawerData, config } from "./config";
import { ProfileCompletionService } from './Services/profile-completion.service';
import { UserService } from "./Services/user.service";
import { WelcomeNewUserComponent } from './components/welcome-new-user/welcome-new-user/welcome-new-user.component';
import Swal from 'sweetalert2';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { filter } from "rxjs/operators";
import { DummyDataService } from "./Services/dummy-data.service";
import { ModalService } from "./Services/modal.service";
import { TokenEncryptionService } from "./Services/token-encryption.service";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDrawer } from "@angular/material/sidenav";
import { OnboardingChecklistService } from './onboarding-checklist/onboarding-checklist.service';
import { hasCompanyRole } from './utils/role.utils';
import { RequestDetailsModalComponent } from "./Admin/data-management/components/request-details-modal/request-details-modal.component";
import { RequestDetailsComponent } from "./Admin/help-and-support/request-details/request-details.component";
import { FeedbackService } from "./Services/feedback.service";
import { FilterDropdownComponent } from "./Admin/reports/reports-header/filter-dropdown/filter-dropdown.component";
import { EntitlementsService } from "./Services/entitlements.service";
import { DemoEnvironmentService, DemoPersona } from "./Services/demo-environment.service";
import { EntitlementKey } from "./entitlements/entitlement-keys";
import { ProfessionalPlanAnnouncementDialogComponent } from "./components/professional-plan-announcement-dialog/professional-plan-announcement-dialog.component";
import { WhatsAppDailySummaryPromptService } from "./Services/whatsapp-daily-summary-prompt.service";
import { captureEmailAdminLanding } from "./utils/email-landing.util";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false
})
export class AppComponent {

  isLoggedIn = JSON.parse(localStorage.getItem("isLogedIn"));
  token = null;
  title = "SuperSee";
  sideMenu = false;
  sideMenuMode = 'over';
  isAdmin = JSON.parse(localStorage.getItem("isAdmin")) || false;
  isUserManager = false;
  quotaStatus = 'active';
  isShowRenewPlan = false;
  public whatsappUrl: string;
  showWhatsAppButton = true;
  onboardingComplete = false;
  isUserOnBoardingPage: Boolean = false;
  isShowingDemoData: boolean = false;
  suppressTrialUx = false;
  activeDemoPersona: DemoPersona | null = null;
  expandedMenus: { [key: string]: boolean } = {
    'reports': false
  };
  isDesktopView = false;
  desktopSidebarCollapsed = false;
  sidebarInteracting = false;
  private readonly desktopSidebarStorageKey = 'desktopSidebarCollapsed';
  componentDrawerSubjectSubscriber !: Subscription;
  componentDrawerWidth: number = 400;

  @ViewChild('drawerInstance') drawerReference!: MatDrawer;

  @ViewChild('componentDrawerInstance') componentDrawerInstance!: MatDrawer;
  @ViewChild('componentReferer', { read: ViewContainerRef }) componentReferer!: ViewContainerRef;

  // Initialize FeedbackJS with options
  feedback = new Feedback({
    events: true,
    id: 'feedback',
    primary: '#5459D1',
    // place the feedback button on the bottom left
    position: 'left',
    // change text of the feedback button
    btnTitle: 'Provide Feedback'
  });
  screenshotImage: any;
  isOpenOrShow: boolean = false;

  constructor(
    private router: Router,
    private _sharedServices: SharedService,
    private _projectService: ProjectService,
    public tourService: TourService,
    private _tourConfig: TourConfigService,
    public dialog: MatDialog,
    private http: HttpClient,
    private renderer: Renderer2,
    private profileCompletionService: ProfileCompletionService,
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private modalService: ModalService,
    private _dummyDataService: DummyDataService,
    private _cd: ChangeDetectorRef,
    private tokenEncryptionService: TokenEncryptionService,
    private breakpointObserver: BreakpointObserver,
    private onboardingService: OnboardingChecklistService,
    private feedbackService: FeedbackService,
    private entitlementsService: EntitlementsService,
    private demoEnvironment: DemoEnvironmentService,
    private whatsappDailySummaryPrompt: WhatsAppDailySummaryPromptService
  ) {
    this.suppressTrialUx = this.demoEnvironment.shouldSuppressTrialUx();
    if (this.suppressTrialUx) {
      this.activeDemoPersona = this.demoEnvironment.getActivePersonaFromSession();
    }
    this.matIconRegistry.addSvgIcon(
      'whatsapp',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/wp-icon.svg')
    );
    this.entitlementsService.stateChanged$.subscribe(() => {
      this._cd.markForCheck();
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      captureEmailAdminLanding(event.urlAfterRedirects);

      const path = this.normalizedPath(event.urlAfterRedirects);
      if (path === '/reports/productivity-trends') {
        this.router.navigateByUrl('/productivity-trends', { replaceUrl: true });
        return;
      }

      const currentRoute = event.urlAfterRedirects;
      this.updateRouteUiClasses(currentRoute);
      this.updateWhatsAppVisibility();
      this.updateHelpRequestsVisibility();

      let message = `Hi, I need help. I'm on the ${currentRoute} page in SuperSee.`;
      if (currentRoute.includes('/onboarding') || currentRoute.startsWith('/setup')) {
        this.isUserOnBoardingPage = true;
      } else {
        this.isUserOnBoardingPage = false;
      }

      this.whatsappDailySummaryPrompt.maybeOpenForCurrentRoute(currentRoute);

      // Update sidenav visibility based on route
      this.checkToken();
      if (this.suppressTrialUx) {
        this.activeDemoPersona = this.demoEnvironment.getActivePersonaFromSession();
      }

      if (currentRoute === '/login' || currentRoute === '/') {
        message = "Hi, I'm having trouble logging in to SuperSee.";
      } else if (currentRoute.includes('/dashboard')) {
        message = "Hi, I have a question about the dashboard in SuperSee.";
      } else if (currentRoute.includes('/employees')) {
        message = "Hi, I have a question about the employees page in SuperSee.";
      } else if (currentRoute.includes('/device-management')) {
        message = "Hi, I have a question about the device management page in SuperSee.";
      } else if (currentRoute.includes('/audit-logs')) {
        message = "Hi, I have a question about the audit logs page in SuperSee.";
      } else if (currentRoute.includes('/projects')) {
        message = "Hi, I have a question about the teams page in SuperSee.";
      } else if (currentRoute.includes('/user-report')) {
        message = "Hi, I have a question about the timesheet page in SuperSee.";
      } else if (currentRoute.includes('/help-support')) {
        message = "Hi, I need some help and support with SuperSee.";
      } else if (currentRoute.includes('/employee/setting')) {
        message = "Hi, I have a question about the settings page in SuperSee.";
      } else if (currentRoute.includes('/billings')) {
        message = "Hi, I have a question about billing in SuperSee.";
      } else if (currentRoute.includes('/billing-invoices')) {
        message = "Hi, I have a question about billing and invoices in SuperSee.";
      } else if (currentRoute.includes('/signup')) {
        message = "Hi, I have a question about signing up for SuperSee.";
      }

      const encodedMessage = encodeURIComponent(message);
      this.whatsappUrl = `https://wa.me/916354719703?text=${encodedMessage}`;
    });
    localStorage.setItem('isTour', 'false')
    this.token = this.tokenEncryptionService.getToken();
    if (this.token) {
      this.getUserFromWP();
    }
    this._sharedServices.isLoggedIn().subscribe((result) => {
      this.token = this.tokenEncryptionService.getToken();
      this.isLoggedIn = result;
      if (this.isLoggedIn) {
        // this.feedback.renderButton();
      } else {
        const element = document.getElementById('feedback-btn');
        if (element) {
          this.renderer.setStyle(element, 'display', 'none');
        }
      }
    })
    this._projectService.isAdminLogin.subscribe(data => {
      if (this.token) {
        this.getUserFromWP();
      }
    })

    // _tourConfig.getTourData();
    // tourService.start()
  }

  updateWhatsAppVisibility(): void {
    const currentRoute = this.router.url;
    this.showWhatsAppButton = !currentRoute.includes('/signup') && !currentRoute.includes('/setup') && this.onboardingComplete;
  }

  private updateRouteUiClasses(route: string): void {
    const body = document?.body;
    if (!body) return;
    const isLiveMonitoring = route.includes('/live-monitoring');
    if (isLiveMonitoring) {
      this.renderer.addClass(body, 'route-live-monitoring');
    } else {
      this.renderer.removeClass(body, 'route-live-monitoring');
    }
    const isExampleWorkday = route.includes('/setup/example-workday');
    if (isExampleWorkday) {
      this.renderer.addClass(body, 'route-example-workday');
    } else {
      this.renderer.removeClass(body, 'route-example-workday');
    }
  }

  tourClose() {
    localStorage.setItem('tourSkipped', 'true');
    localStorage.setItem('isTour', 'false')
    this._projectService.updateDashboardTourData({ data: 'true' })
    this.tourService.end()
    this._projectService.updateTour().subscribe((res: any) => {
      localStorage.setItem('isTour', 'false')
    }, err => { })
  }

  tourEnd() {
    this._projectService.getUserList(0, 0, true)
    localStorage.setItem('tourSkipped', 'true');
    localStorage.setItem('isTour', 'false')
    this._projectService.updateDashboardTourData({ data: 'true' })
    this.tourService.end()
    this._projectService.updateTour().subscribe((res: any) => {
      localStorage.setItem('isTour', 'false');
    }, err => { })
  }

  onDrawerToggle(isOpened: boolean) {
    let element = document.getElementById('feedback-btn');
    if (!isOpened) {
      if (element) this.renderer.setStyle(element, 'display', 'none');
    } else {
      if (element) this.renderer.setStyle(element, 'display', 'flex');
    }
  }

  previousAction(event) {
    // if(event.anchorId == 'addNewEmployee'){
    //   this._sharedServices.dashboardScrollerSubject.next('ss_section');
    // }
    this.tourService.prev()
  }

  ngOnInit() {
    this.restoreDesktopSidebarPreference();
    this.setSubjects();
    this.initFeedbackLib();
    this.updateHelpRequestsVisibility();
    // Subscribe to demo data visibility
    this._dummyDataService.isShowingDemoData$.subscribe((isShowing) => {
      this.isShowingDemoData = isShowing;
      // Keep the maintenance banner from overlapping the fixed sample-data banner.
      setTimeout(() => this.updateMaintenanceBannerOffset(), 0);
    });

    // Subscribe to onboarding state to track completion
    this.onboardingService.state$.subscribe(state => {
      this.onboardingComplete = state.steps.every(s => s.completed);
      this.updateWhatsAppVisibility();
      this._cd.detectChanges();
    });

    // Subscribe to onboarding panel expansion state
    this.onboardingService.isPanelExpanded().subscribe(isExpanded => {
      // Hide WhatsApp when panel is expanded
      if (isExpanded) {
        this.showWhatsAppButton = false;
      } else {
        this.updateWhatsAppVisibility();
      }
      this._cd.detectChanges();
    });
    //     if (tour == 'false') {
    //       this.sideMenu = !this.sideMenu;
    //       this.sideMenuMode = 'over';
    //     }
    //   } else {
    //     this.sideMenu = result;
    //     this.sideMenuMode = 'side';
    //   }
    // });

    // if (window.screen.width <= 1200 && tour == 'false') {
    //   this.sideMenuMode = 'over';
    // } else if (window.screen.width >= 1200) {
    //   this.sideMenuMode = 'side';
    // }

    if (localStorage.getItem('selectedData')) {
      localStorage.removeItem('selectedData');
    }

    if (localStorage.getItem('isOpenedWelcomeDialog')) {
      localStorage.removeItem('isOpenedWelcomeDialog');
    }
    // this.feedback.renderButton();

    window.addEventListener('feedback-submit', (event) => {
      this.handleFeedbackSubmit((event as CustomEvent).detail);
    });

    // Defer checkToken to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => this.checkToken(), 0);

    this._sharedServices.isOpenCloseSidebar.subscribe((res) => {
      if (res) {
        if (res.force) {
          this.checkToken(true);
        } else {
          this.checkToken();
        }
      } else {
        setTimeout(() => {
          this.isOpenOrShow = false;
          this.updateMaintenanceBannerOffset();
        }, 0);
      }
    })

    this._sharedServices.isTriggerWelcomeModal.subscribe((res) => {
      if (res) {
        if (res.force) {
          this.openWelcomeNewUserDialog(true);
        } else {
          this.openWelcomeNewUserDialog();
        }
      }
    })
  }

  ngAfterViewInit() {
    this.breakPointCheckers();
    if (this.token && this.drawerReference) {
      if (this.isUserOnBoardingPage) {
        this._cd.detectChanges();
      } else {
        this.drawerReference.open();
        this._cd.detectChanges();
      }
    } else {
      setTimeout(() => {
        this.isOpenOrShow = false;
        this._cd.detectChanges();
      }, 0);
    }
  }

  checkToken(forceOpen = false) {
    this.token = this.tokenEncryptionService.getToken();
    if (this.token) {
      if (this.isUserOnBoardingPage && !forceOpen) {
        setTimeout(() => {
          this.isOpenOrShow = false;
          this._cd.detectChanges();
        }, 0);
      } else {
        setTimeout(() => {
          this.isOpenOrShow = true;
          let res = this.breakpointObserver.isMatched([Breakpoints.Handset, Breakpoints.Tablet]);
          if (!res) {
            this.drawerReference?.open();
          }
          this._cd.detectChanges();
          this.updateMaintenanceBannerOffset();
        }, 0);
      }
    } else {
      setTimeout(() => {
        this.isOpenOrShow = false;
        this._cd.detectChanges();
        this.updateMaintenanceBannerOffset();
      }, 0);
    }

  }

  /**
   * When the fixed sample-data banner is visible, move the fixed maintenance banner down
   * so both notices are readable and never overlap.
   */
  private updateMaintenanceBannerOffset(): void {
    try {
      const sampleBanner = document.querySelector('.sample-data-banner') as HTMLElement | null;
      const height = sampleBanner ? sampleBanner.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--maintenance-banner-offset', `${height}px`);
    } catch {
      // Safe no-op in non-browser contexts.
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let element = document.getElementById('feedback-btn');
    // this.innerWidth = window.innerWidth;
    if (window.screen.width <= 1200) {
      // this.sideMenu = false;
      // this.sideMenuMode = 'over';
      if (element) this.renderer.setStyle(element, 'display', 'none');
    } else if (window.screen.width > 1200) {
      // this.sideMenu = true;
      // this.sideMenuMode = 'side';
      if (element) this.renderer.setStyle(element, 'display', 'flex');
    }
  }

  private pathWithoutQuery(url: string): string {
    const q = url.indexOf('?');
    return q >= 0 ? url.slice(0, q) : url;
  }

  /** Path only: no query, hash, or trailing slash (except '/'). */
  private normalizedPath(url: string): string {
    let path = this.pathWithoutQuery(url);
    const hashIdx = path.indexOf('#');
    if (hashIdx >= 0) {
      path = path.slice(0, hashIdx);
    }
    if (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1);
    }
    return path;
  }

  private isAppWebsiteUsageReportsRoute(): boolean {
    return this.normalizedPath(this.router.url) === '/reports';
  }

  checkIsActive(currentRoute: string) {
    const path = this.normalizedPath(this.router.url);
    const rawUrl = this.router.url;

    if (currentRoute === path || (currentRoute === '/dashboard' && path === '/')) {
      return 'active-nav';
    }
    if (currentRoute === '/reports' && path === '/reports') {
      return 'active-nav';
    }
    if (
      currentRoute === '/productivity-trends' &&
      (path.startsWith('/productivity-trends') || path === '/reports/productivity-trends')
    ) {
      return 'active-nav';
    }
    if (currentRoute === '/employees' && path.includes('/user-details')) {
      return 'active-nav';
    }
    if (currentRoute === '/employees' && rawUrl.includes('/employees?filter')) {
      return 'active-nav';
    }
    if (currentRoute === '/device-management' && path.includes('/device-management')) {
      return 'active-nav';
    }
    if (currentRoute === '/audit-logs' && path.startsWith('/audit-logs')) {
      return 'active-nav';
    }
    if (currentRoute === '/user-report' && path.includes('/user-report')) {
      return 'active-nav';
    }
    if (currentRoute === '/employee/setting' && path.includes('/employee/setting')) {
      return 'active-nav';
    } else if (currentRoute == '/billing-invoices' && (this.router.url.includes('/billing-invoices') == true)) {
      return 'active-nav';
    }
    if (currentRoute === '/work-replay' && path.startsWith('/work-replay')) {
      return 'active-nav';
    }
  }

  checkSideMenu() {
    if (window.screen.width <= 991) {
      this.sideMenu = false;
      this.drawerReference.close();
    }
  }

  toggleMenu(menuName: string) {
    this.expandedMenus[menuName] = !this.expandedMenus[menuName];
  }

  onReportsInteraction(event: Event) {
    if (this.isDesktopCollapsedMode()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.toggleMenu('reports');
  }

  isDesktopCollapsedMode(): boolean {
    return this.isDesktopView && this.desktopSidebarCollapsed;
  }

  /** Sidebar billing CTA — null hides the green footer button (no empty shell). */
  sidebarBillingAction(): { icon: string; label: string } | null {
    if (!this.isShowRenewPlan || !this.isAdmin || this.suppressTrialUx) {
      return null;
    }
    const status = (this.quotaStatus || '').toLowerCase();
    if (status === 'trial' || status === 'trial-expired') {
      return { icon: 'shopping_cart', label: 'Buy' };
    }
    if (status === 'active') {
      return { icon: 'restart_alt', label: 'Renew' };
    }
    if (status === 'expired') {
      return { icon: 'restart_alt', label: 'Upgrade' };
    }
    return null;
  }

  toggleDesktopSidebar() {
    if (!this.isDesktopView) {
      return;
    }

    this.desktopSidebarCollapsed = !this.desktopSidebarCollapsed;
    localStorage.setItem(this.desktopSidebarStorageKey, JSON.stringify(this.desktopSidebarCollapsed));
  }

  setSidebarInteracting(isInteracting: boolean) {
    this.sidebarInteracting = isInteracting;
  }

  restoreDesktopSidebarPreference() {
    const savedPreference = localStorage.getItem(this.desktopSidebarStorageKey);
    this.desktopSidebarCollapsed = savedPreference ? JSON.parse(savedPreference) : false;
  }

  readonly entitlementKeys = EntitlementKey;

  /** Nav visibility when WP entitlements v2 is active; always true when enforcement off. */
  canShowCompanyEntitlement(key: string): boolean {
    return this.entitlementsService.hasCompany(key);
  }

  /** Show gated nav item (legacy: hide only when v2 off and not entitled — fail-open shows all). */
  private showGatedNavItem(key: string): boolean {
    if (!this.entitlementsService.isEnforcementActive()) {
      return this.entitlementsService.hasCompany(key);
    }
    return true;
  }

  isNavEntitlementLocked(key: string): boolean {
    return this.entitlementsService.isCompanyLocked(key);
  }

  lockedNavTooltip(key: string): string {
    return `Upgrade to unlock ${this.entitlementsService.getLabel(key)}`;
  }

  onEntitlementNavClick(event: Event, key: string): void {
    if (!this.isNavEntitlementLocked(key)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const keys =
      key === EntitlementKey.live_screencast
        ? `${EntitlementKey.live_screencast},${EntitlementKey.live_wall}`
        : key;
    void this.router.navigate(['/feature-locked'], {
      queryParams: {
        keys,
        returnUrl: this.router.url.split('?')[0] || '/dashboard',
      },
    });
    this.checkSideMenu();
  }

  onFlyoutEntitlementClick(event: Event, key: string): void {
    if (this.isNavEntitlementLocked(key)) {
      this.onEntitlementNavClick(event, key);
      return;
    }
    this.checkSideMenu();
  }

  showWebsiteUsageNav(): boolean {
    return this.showGatedNavItem(EntitlementKey.website_usage);
  }

  showProductivityTrendsNav(): boolean {
    return this.showGatedNavItem(EntitlementKey.productivity_trends)
      || this.showGatedNavItem(EntitlementKey.productivity_trends_preview);
  }

  canAccessProductivityTrends(): boolean {
    return this.entitlementsService.canAccessProductivityTrends();
  }

  isProductivityTrendsNavLocked(): boolean {
    return this.entitlementsService.isEnforcementActive()
      && !this.canAccessProductivityTrends();
  }

  onProductivityTrendsNavClick(event: Event): void {
    if (!this.isProductivityTrendsNavLocked()) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    void this.router.navigate(['/feature-locked'], {
      queryParams: {
        keys: EntitlementKey.productivity_trends,
        returnUrl: this.router.url.split('?')[0] || '/dashboard',
      },
    });
    this.checkSideMenu();
  }

  onProductivityTrendsFlyoutClick(event: Event): void {
    if (this.isProductivityTrendsNavLocked()) {
      this.onProductivityTrendsNavClick(event);
      return;
    }
    this.checkSideMenu();
  }

  showLiveMonitoringNav(): boolean {
    return this.showGatedNavItem(EntitlementKey.live_screencast)
      || this.showGatedNavItem(EntitlementKey.live_wall);
  }

  canAccessLiveMonitoring(): boolean {
    return this.entitlementsService.hasCompany(EntitlementKey.live_screencast)
      || this.entitlementsService.hasCompany(EntitlementKey.live_wall);
  }

  isLiveMonitoringNavLocked(): boolean {
    return this.entitlementsService.isEnforcementActive()
      && !this.canAccessLiveMonitoring();
  }

  showWorkReplayNav(): boolean {
    if (!this.entitlementsService.isEnforcementActive()) {
      return this.entitlementsService.hasCompany(EntitlementKey.work_replay);
    }
    return true;
  }

  isWorkReplayNavLocked(): boolean {
    return this.entitlementsService.isEnforcementActive()
      && !this.entitlementsService.canAccessWorkReplay();
  }

  onWorkReplayNavClick(event: Event): void {
    if (!this.isWorkReplayNavLocked()) {
      return;
    }
    this.onEntitlementNavClick(event, EntitlementKey.work_replay);
  }

  showDataManagementNav(): boolean {
    if (!this.entitlementsService.isEnforcementActive()) {
      return this.entitlementsService.hasCompany(EntitlementKey.data_management);
    }
    return this.entitlementsService.canAccessDataManagement();
  }

  showDeviceManagementNav(): boolean {
    return false;
  }

  showAuditLogsNav(): boolean {
    return this.showGatedNavItem(EntitlementKey.live_wall);
  }

  isReportsRouteActive(): boolean {
    const path = this.normalizedPath(this.router.url);
    return (
      path.includes('/user-report') ||
      path === '/reports' ||
      path.startsWith('/productivity-trends') ||
      path === '/reports/productivity-trends'
    );
  }

  getUserFromWP() {
    let roleArr = [];
    this._projectService.getUser().subscribe((data: any) => {
      // First, set the user in the centralized UserService to make it available everywhere.
      this.userService.setCurrentUser(data);

      if (data.meta && data.meta.report_recipient_emails) {
        this._sharedServices.updateTheRecipientsMail('update', data.meta.report_recipient_emails);
      }
      // Now that the user data is fresh, run the profile completion check.

      this.tokenEncryptionService.setEncryptedItem('user', data);
      this.entitlementsService.syncFromUser(data);

      // Set the user data in dummy data service
      this._dummyDataService.setUserData = data;

      // Set dbPath if it's not already set (for existing logged-in users)
      if (!this.tokenEncryptionService.getEncryptedItem<string>('dbPath') && data.id) {
        const dbPath = `/users/${data.id}`;
        this.tokenEncryptionService.setEncryptedItem('dbPath', dbPath);
        console.log('Setting dbPath for existing user:', dbPath);
      }

      let isExpired = this._sharedServices.checkPlanExpired(data)
      if (isExpired) {
        return this.router.navigateByUrl('/plan-expired');
      }
      roleArr = data.role;
      this.quotaStatus = data.meta.quota_status;
      let checkDayDiff = this.expiringDate(data.meta.expires_at, data.meta.today_date);
      const subscriptionStatus = (data.meta.subscription_status || '').toLowerCase();

      if (this.suppressTrialUx) {
        this.isShowRenewPlan = false;
      } else if (subscriptionStatus === 'active') {
        this.isShowRenewPlan = false;
      } else if (this.quotaStatus == 'active' || this.quotaStatus == 'Active') {
        this.isShowRenewPlan = checkDayDiff <= data.meta.adv_pay;
      } else if (
        this.quotaStatus == 'trial' ||
        this.quotaStatus == 'Trial' ||
        this.quotaStatus == 'trial-expired' ||
        this.quotaStatus == 'Trial-expired' ||
        this.quotaStatus == 'expired' ||
        this.quotaStatus == 'Expired'
      ) {
        this.isShowRenewPlan = true;
      } else {
        this.isShowRenewPlan = false;
      }

      let isUserManager = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("manager"));
      })

      this.isAdmin = hasCompanyRole(data);
      if (isUserManager.length == 0) {
        this.isUserManager = false;
      } else {
        this.isUserManager = true;
      }

      // Non-interruptive trial UX: optional welcome/demo lives on Dashboard banner and Help — no modal on login.
      this.checkProfessionalPlanDialog(data);
      // Defer WhatsApp phone popup until a non-setup route (Ready already asks inline).
      this.whatsappDailySummaryPrompt.rememberUser(data);
      this.whatsappDailySummaryPrompt.maybeOpenForCurrentRoute();

    })
  }

  public isProfessionalDialogOpened: boolean = false;

  checkProfessionalPlanDialog(data: any) {
    const planCode = data?.meta?.plan_code;
    const seen = localStorage.getItem('professional-plan-announcement-seen');
    const isAdminUser = this.isAdmin;

    if (planCode === 'professional' && !seen && isAdminUser && !this.isProfessionalDialogOpened && this.quotaStatus !== 'trial') {
      // Set instance flag to prevent double-opening during rapid method calls
      this.isProfessionalDialogOpened = true;

      const companyName = data?.meta?.company_name || data?.name || '';

      const dialogRef = this.dialog.open(ProfessionalPlanAnnouncementDialogComponent, {
        width: 'auto',
        maxWidth: '95vw',
        disableClose: false,
        autoFocus: false,
        panelClass: 'professional-plan-dialog-container',
        data: { companyName }
      });

      dialogRef.afterClosed().subscribe((result) => {
        // Only mark as permanently seen if the user explicitly clicked "Got It" or the "Close" button
        // (which pass result = true). If they just refresh the page, it won't be set.
        if (result) {
          localStorage.setItem('professional-plan-announcement-seen', 'true');
        }
        this.isProfessionalDialogOpened = false; // Reset in case they somehow trigger it again
      });
    }
  }

  checkMilestonesAndTriggerTour(data: any) {
    const tourSkipped = localStorage.getItem('tourSkipped');
    const tourTakenOrSkipped = tourSkipped === 'true' || (data.meta && (data.meta.ss_tooltip_visited === 'true' || data.meta.ss_tooltip_visited === true));

    if (tourTakenOrSkipped) {
      return;
    }

    // Fetch the user list to check for any activity.
    this._projectService.getUserList(0, 0).subscribe((response: any) => {
      // The getUserList service returns the array directly.
      const users = response;

      // Guard against an unexpected response format.
      if (!Array.isArray(users)) {
        console.error("Could not check for tour milestones: getUserList response was not in the expected format.", response);
        return;
      }

      // Check if any user has recorded a screenshot or app activity.
      const milestoneReached = users.some(user =>
        (user.meta && user.meta.last_screenshot) || (user.meta && user.meta.last_application_name)
      );

      if (milestoneReached) {
        this.dialog.closeAll();
        this.openDialog(WelcomeComponent, {
          panelClass: 'centered-dialog',
        }).subscribe(() => { });
        localStorage.setItem('tourStart', 'true');
      }
    }, (error) => {
      console.error("Error fetching user list for tour check:", error);
    });
  }

  showProfileCompletionPopup(missingFields: string[] = []) {
    let missingFieldsText = '';
    if (missingFields.length > 0) {
      missingFieldsText =
        '<div style="text-align: left; margin-bottom: 1rem;">' +
        '<p style="margin-bottom: 4px;">Please update the following fields:</p>' +
        '<b>' +
        missingFields.join(', ') +
        '</b>' +
        '</div>';
    }

    Swal.fire({
      title: '👋 Welcome to SuperSee!',
      html:
        missingFieldsText +
        '<div style="text-align: left;">' +
        '<p>To ensure the best experience, please complete your profile by adding your contact and company details.</p>' +
        '<p>This helps us personalize insights, enable key features, and provide better support throughout your journey.</p>' +
        '</div>',
      allowOutsideClick: true,
      allowEscapeKey: true,
      showConfirmButton: true,
      confirmButtonText: 'Complete Profile',
      showCancelButton: true,
      cancelButtonText: 'Remind Me Later'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/user-profile-info']);
      }
    });
  }

  moveTeamList() {
    if (localStorage.getItem('selectedData')) {
      localStorage.removeItem('selectedData');
    }
    this.router.navigate([`/projects`]);
    this._sharedServices.dashboardScrollerSubject.next('addTeamBox');
  }

  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, {
      data,
      panelClass: 'centered-dialog',
    });
    return dialogRef.afterClosed();
  }

  // expiringDate(strDate: any, strToday: any) {
  //   const expirationDate = new Date(strDate);
  //   const timeDifference = expirationDate.getTime() - new Date(strToday).getTime();
  //   const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
  //   let isExpirationNear = daysDifference < 15;

  //   // this.daysRemaining = Math.round(daysDifference);
  //   return isExpirationNear;
  // }

  expiringDate(strExpiredDate, strTodayDate) {
    const expirationDate = new Date(strExpiredDate);
    const timeDifference = expirationDate.getTime() - new Date(strTodayDate).getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return daysDifference + 1;
  }

  async handleFeedbackSubmit(feedbackData) {
    const screenshotElement = document.querySelector('#screenshotArea') as HTMLElement;
    await html2canvas(screenshotElement).then((canvas) => {
      this.screenshotImage = canvas.toDataURL().split(',')[1];
    });

    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');

    let feedbackPayload = {
      version: require('../../package.json').version,
      feedbackType: feedbackData.feedbackType,
      plan: this.quotaStatus,
      feedback: feedbackData.message,
      currentPage: this.router.url,
      osInformation: platform.os.family + ' ' + platform.os.version + ' ( ' + platform.description + ' )',
      currentBrowser: platform.name + ' ' + platform.version,
      currentPageScreenshot: this.screenshotImage,
      email: user?.email || '',
      name: `${user?.first_name || ''} ${user?.last_name || ''}`.trim(),
    };

    const headers = new HttpHeaders({
      'Content-Type': 'text/plain;charset=utf-8',
    });
    this.http.post(config.feedBackSheet, feedbackPayload, { headers }).subscribe(
      (response) => {
        console.log('response :: ', response);
      },
      (error) => {
        console.error("ERROR in submit feedback", error);
      }
    );

  }

  openWelcomeNewUserDialog(force = false) {
    // Hide welcome popup on desktop — onboarding checklist handles setup flow
    if (window.innerWidth > 768 && !/Mobi|Android/i.test(navigator.userAgent)) {
      return;
    }
    this._projectService.getUserList(0, 0).subscribe((response: any) => {
      // Guard against an unexpected response format.
      if (!Array.isArray(response)) {
        console.error("CHECK ARRAY TYPE NOT VALID", response);
        return;
      }

      const users = response;
      if (users.length <= 0 && this.quotaStatus == 'trial') {
        const isAlreadyOpen = this.modalService.isAlreadyOpenDialog(WelcomeNewUserComponent);
        // const isAlreadyOpen = this.dialog.openDialogs.some(dialogRef => dialogRef.componentInstance instanceof WelcomeNewUserComponent);
        const isOpenedWelcomeDialog = localStorage.getItem('isOpenedWelcomeDialog');
        let isAdminUser = false;
        // 'user' is encrypted in localStorage; always access via TokenEncryptionService.
        const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
        const rawRoles = user?.role;
        const roles: string[] = Array.isArray(rawRoles)
          ? rawRoles
          : (typeof rawRoles === 'string' && rawRoles ? [rawRoles] : []);

        if (user) {
          isAdminUser = hasCompanyRole(user);
        }



        if ((!isAlreadyOpen && !isOpenedWelcomeDialog || isOpenedWelcomeDialog == 'false') && isAdminUser && !this.isUserOnBoardingPage) {
          this.modalService.openCommonMatDialog(WelcomeNewUserComponent, {
            className: 'welcomeUser-dialog',
            maxHeight: '90vh',
            disableClose: true,
          })
          // this.dialog.open(WelcomeNewUserComponent, {
          //   panelClass: 'welcomeUser-dialog',
          //   maxHeight: '90vh',
          //   disableClose: true,
          // });
          localStorage.setItem('isOpenedWelcomeDialog', 'true');
        }

        if ((!isAlreadyOpen && !isOpenedWelcomeDialog || isOpenedWelcomeDialog == 'false') && isAdminUser && force) {
          this.modalService.openCommonMatDialog(WelcomeNewUserComponent, {
            className: 'welcomeUser-dialog',
            maxHeight: '90vh',
            disableClose: true,
          })
          // this.dialog.open(WelcomeNewUserComponent, {
          //   panelClass: 'welcomeUser-dialog',
          //   maxHeight: '90vh',
          //   disableClose: true,
          // });
          localStorage.setItem('isOpenedWelcomeDialog', 'true');
        }
      } else {

        const milestoneReached = users.some(user =>
          (user.meta && user.meta.last_screenshot) || (user.meta && user.meta.last_application_name)
        );

        if (milestoneReached) {
          this.profileCompletionService.checkProfileCompletion();
        }
      }

    }, (error) => {
      console.error("Error fetching user list for tour check:", error);
    });
  }

  breakPointCheckers() {
    let tour = localStorage.getItem('isTour');

    this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).subscribe((res) => {
      this.isDesktopView = !res.matches;
      // Desktop collapsed state should persist across sessions.
      // Restore when entering desktop view; ignore collapsed mode on handheld/tablet.
      if (this.isDesktopView) {
        this.restoreDesktopSidebarPreference();
      } else {
        this.desktopSidebarCollapsed = false;
      }
      if (res.matches && tour == 'false') {
        this.sideMenuMode = 'over';
        this.drawerReference?.open();
      } else {
        this.sideMenuMode = 'side';
        this.drawerReference?.open();
      }
    })

    this._sharedServices.sideMenuSubject.subscribe((result: any) => {
      let res = this.breakpointObserver.isMatched([Breakpoints.Handset, Breakpoints.Tablet]);
      if (res && tour == 'false') {
        this.sideMenuMode = 'over';
        if (this.drawerReference?.opened) {
          this.drawerReference?.close();
        } else {
          this.drawerReference?.open();
        }
      } else {
        this.sideMenuMode = 'side';
        if (result) {
          this.drawerReference?.open();
        } else {
          this.drawerReference?.close();
        }
      }
    })
  }

  setSubjects() {
    this.componentDrawerSubjectSubscriber = this._sharedServices.componentDrawerSubject.subscribe((result: ComponentDrawerData) => {
      this.drawerInstanceManager(result);
    });

    this._sharedServices.openHelpRequestDialogSubject.subscribe((data) => {
      this._sharedServices.openCreateRequestDialog(data);
    });
  }

  drawerInstanceManager(actionDetails: ComponentDrawerData) {
    if (actionDetails.componentAction == "close") {
      this.componentDrawerInstance.close();
      this.componentReferer.clear();
      return;
    }
    let createdComponent;
    switch (actionDetails.componentName) {
      case "data-management":
        this.componentReferer.clear();
        this.componentDrawerWidth = actionDetails.componentWidth;
        createdComponent = this.componentReferer.createComponent(RequestDetailsModalComponent);
        createdComponent.setInput('requestId', actionDetails.componentData.id);
        this.componentDrawerInstance.open();
        break;
      case "help-and-support":
        this.componentReferer.clear();
        this.componentDrawerWidth = actionDetails.componentWidth;
        const helpSupportComponent = this.componentReferer.createComponent(RequestDetailsComponent);
        helpSupportComponent.setInput('requestDetails', actionDetails.componentData);
        this.componentDrawerInstance.open();
        break;
      case "reports-filter":
        this.componentReferer.clear();
        this.componentDrawerWidth = actionDetails.componentWidth;
        createdComponent = this.componentReferer.createComponent(FilterDropdownComponent);
        createdComponent.setInput('filterData', actionDetails.componentData);
        this.componentDrawerInstance.open();
        break;
    }
  }

  initFeedbackLib() {
    this.feedbackService.initFeedback();
  }

  updateHelpRequestsVisibility(): void {
    const currentRoute = this.router.url;
    const element = document.getElementById('feedback-root');
    if (element) {
      if (
        currentRoute.includes('/signup') ||
        currentRoute.includes('/login') ||
        currentRoute.includes('/forgot-password') ||
        currentRoute.includes('/setup/example-workday')
      ) {
        this.renderer.setStyle(element, 'display', 'none');
      } else {
        this.renderer.setStyle(element, 'display', 'block');
      }
    }
  }
}
